// (function (app, core) {
//     'use strict';

//     const MENU_SCROLL_LIMIT_DESKTOP = 400;
//     const MENU_SCROLL_LIMIT_MOBILE = 250;
//     const BOTTOM_SCROLL_LIMIT = 100;
//     const MOBILE_BREAKPOINT = window.matchMedia('(max-width: 1025px)');

//     app.FixturesNav = function (container) {
//         const _self = this;
//         _self.container = container;
//         _self.header = document.querySelector('.main-header');
//         _self.contentInner = document.querySelector('.fixtures-content--inner');
//         // _self.stickyNav();
//     };

//     /**
//      * Set the window scroll listener for sticky fixtures main nav & secondary menu
//      */
//     app.FixturesNav.prototype.stickyNav = function () {
//         const _self = this;

//         const scrollLimit = MOBILE_BREAKPOINT.matches
//             ? MENU_SCROLL_LIMIT_MOBILE
//             : MENU_SCROLL_LIMIT_DESKTOP;

//         window.addEventListener(
//             'scroll',
//             () => {
//                 const maxScroll =
//                     _self.contentInner.offsetHeight + BOTTOM_SCROLL_LIMIT;
//                 const topScroll =
//                     window.pageYOffset || document.documentElement.scrollTop;

//                 if (topScroll > maxScroll) {
//                     core.style.removeClass(_self.container, 'isSticky');
//                     return;
//                 }
//                 if (topScroll > scrollLimit) {
//                     core.style.addClass(_self.container, 'isSticky');
//                     core.style.addClass(_self.header, 'u-hide');
//                 } else {
//                     core.style.removeClass(_self.container, 'isSticky');
//                     core.style.removeClass(_self.header, 'u-hide');
//                 }
//             },
//             false
//         );
//     };

//     let widgets = document.querySelectorAll(
//         '[data-widget="fixtures-secondary-nav"]'
//     );

//     Array.prototype.forEach.call(widgets, function (widget) {
//         new app.FixturesNav(widget);
//     });
// })(PULSE.app, PULSE.core, PULSE.ui);
